import styled from 'styled-components'

export const Content = styled.main`
	height: 100%;
`
